import classNames from 'classnames'

import {
  ACTIVITIES_DND_TYPE,
  QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_DRAG_HANDLE,
} from '../../RequestProfileTabActivities.constants'
import {
  useRequestProfileTabActivitiesContext,
  useRequestProfileTabActivitiesSortableItem,
} from '../../RequestProfileTabActivities.hooks'
import { getActivityDndId } from '../../RequestProfileTabActivities.utils'
import { RequestProfileTabActivitiesDragHandle } from '../../RequestProfileTabActivitiesDragHandle'
import { RequestProfileTabActivitiesTableRow } from '../../RequestProfileTabActivitiesTableRow'

import * as styles from './RequestProfileTabActivitiesSortableTableRow.module.css'

function RequestProfileTabActivitiesSortableTableRow({
  canDrag,
  className,
  disabled,
  item,
  phaseId,
  ...props
}) {
  const { isReorderingActivities } = useRequestProfileTabActivitiesContext()

  const { attributes, dropIndicator, listeners, setNodeRef, style } =
    useRequestProfileTabActivitiesSortableItem({
      data: { item, phaseId, type: ACTIVITIES_DND_TYPE.activity },
      disabled: !canDrag || isReorderingActivities,
      id: getActivityDndId(item.id),
      type: ACTIVITIES_DND_TYPE.activity,
    })

  return (
    <div
      className={styles.sortableRow}
      data-drop-indicator={dropIndicator}
      ref={setNodeRef}
      style={style}
    >
      {canDrag ? (
        <RequestProfileTabActivitiesDragHandle
          className={styles.dragHandle}
          dragHandleProps={{ ...attributes, ...listeners }}
          qaName={QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_DRAG_HANDLE}
        />
      ) : null}
      <RequestProfileTabActivitiesTableRow
        {...props}
        className={classNames(styles.rowContent, className)}
        disabled={disabled}
        item={item}
      />
    </div>
  )
}

export default RequestProfileTabActivitiesSortableTableRow
